import { AfterContentInit, Component, ContentChild, inject, Input, TemplateRef, ViewChild } from "@angular/core";

import { DATE_FORMAT } from "@intocare/util";

import { TableComponent } from "../../table/table.component";

@Component({
	selector: "ic-table-date-cell",
	template: `
		<ng-template #cellTmpl let-item>
			<time>{{ item | date: format }}</time>
		</ng-template>
	`,
	standalone: false,
})
export class TableDateCellComponent implements AfterContentInit {
	private readonly parent = inject(TableComponent);

	@Input() key: string;
	@Input() format = DATE_FORMAT.DISPLAY_MEDIUM;

	@ContentChild("headerTmpl", { static: false }) headerTemplate: TemplateRef<any>;
	@ContentChild("footerTmpl", { static: false }) footerTemplate: TemplateRef<any>;

	@ViewChild("cellTmpl", { static: true }) cellTemplate: TemplateRef<any>;

	ngAfterContentInit() {
		const template = {
			header: this.headerTemplate,
			cell: this.cellTemplate,
			footer: this.footerTemplate,
		};

		this.parent.register(this.key, template);
	}
}
